export enum CaseWorkItemStatusEnum {
  Pending      = '00000167-1000-0000-0000-000000000001',
  InProgress   = '00000167-1000-0000-0000-000000000002',
  Completed    = '00000167-1000-0000-0000-000000000003',
  Canceled     = '00000167-1000-0000-0000-000000000004',
  Hold         = '00000167-1000-0000-0000-000000000005',
}
